// extracted by mini-css-extract-plugin
var _1 = "epFqRSApyal5r41RML47";
var _2 = "YDE4JOlQcD83NGBw87jx";
var _3 = "o6FhpdFo1pjpI8vyKrtn";
var _4 = "liU_lkDgmHaB1P66NGy0";
var _5 = "Upol3tSyhcpYZZLOprdg";
export { _1 as "socialMediaLinksBlock", _2 as "socialMediaLinksWrapper", _3 as "socialMediaList", _4 as "socialMediaListItem", _5 as "socialMediaListTitle" }
